<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="row">
        <div class="col-xs-12">
          <h5>
            My Tasks
          </h5>
        </div>

        <div v-if="!loading" style="margin-top: 4px">
          <div class="col-xs-6">
            <select-widget
                v-model="horizon"
                class="form-control input-sm"
                :nullable="true"
                placeholder="(today)"
                :options="horizonOptions"
            ></select-widget>
          </div>

          <div class="col-xs-6">
            <select-widget
                v-model="taskType"
                class="form-control input-sm"
                :nullable="true"
                placeholder="(all task types)"
                :options="taskTypeOptions"
            ></select-widget>
          </div>
        </div>
      </div>
    </div>

    <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

    <ul v-else class="list-group">
      <li v-for="(task, index) in tasks.data" class="list-group-item" style="padding: 10px 0" :class="{'list-group-item-danger': task.type === 'closing-subscription'}">
        <div style="display: flex; flex-direction: row">
          <div class="text-muted"
               style="flex: 1; font-size: 24px; display: flex; justify-content: center; align-items: center;">
            <task-list-icon :task="task"></task-list-icon>
          </div>

          <div style="flex: 7 1 0%;">
            <router-link :to="'/' + task.attributes.subject_type + '/' + task.attributes.subject_id">
              {{ task.attributes.subject_name }}
            </router-link>

            <br>

            <span v-tooltip="task.attributes.tooltip" v-html="task.attributes.description"></span>

            <br>

            <i class="text-muted" :style="{color: getDiff(task) < 0 ? '#d9534f' : 'inherit'}">
              {{ getDeadlineDescription(task) }}
            </i>
          </div>

          <div style="flex: 1; font-size: 24px; display: flex; justify-content: flex-end; align-items: center;">
            <button type="button" class="btn btn-lg" @click="complete(task, index)" style="background-color: transparent">
              <i class="fa fa-check-circle"></i>
            </button>
          </div>
        </div>
      </li>

      <li v-if="tasks.data.length === 0" class="list-group-item text-center" style="padding: 50px;">
        <i class="fa fa-tasks" style="font-size: 96px;"></i>

        <br><br>

        You have no tasks to complete!
      </li>
    </ul>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import moment from 'moment'
import notify from '@/notify'
import Load from '@/mixins/Load'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SaveHeight from '@/mixins/SaveHeight'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TaskListIcon from '@/pages/Dashboards/MyFocus/Panels/TaskList/TaskListIcon'

export default {
  components: {LoadingSpinner, SelectWidget, TaskListIcon},

  mixins: [Load, SaveHeight],

  data() {
    return {
      taskType: null,
      horizon: null,
      tasks: null,
      taskTypes: null
    }
  },

  mounted() {
    this.fetch()
  },

  watch: {
    taskType() {
      this.fetch()
    },

    horizon() {
      this.fetch()
    }
  },

  computed: {
    deadline() {
      return 'In ' + moment().diff(moment()) + ' days'
    },

    taskTypeOptions() {
      return this.taskTypes.data.map(taskType => {
        return {
          value: taskType.id,
          label: taskType.attributes.name
        }
      })
    },

    horizonOptions() {
      return [
        {value: 1, label: '+1 days'},
        {value: 2, label: '+2 days'},
        {value: 3, label: '+3 days'},
        {value: 7, label: '+7 days'},
        {value: 14, label: '+14 days'},
        {value: 30, label: '+30 days'}
      ]
    }
  },

  methods: {
    fetch() {
      this.saveHeight()

      this.load({
        tasks: '/api/v2/tasks?filter[horizon]=' + (this.horizon !== null ? this.horizon : 0) + '&filter[category]=' + (this.taskType !== null ? this.taskType : ''),
        taskTypes: '/api/v2/task-types'
      })
    },

    complete(task, index) {
      modal.confirm('Are you sure that you want to complete the task?', () => {
        http.post('/api/v1/completed-tasks', {type: task.attributes.category, ...task.attributes.parameters})
            .then(() => {
              this.tasks.data.splice(index, 1)

              notify.success('The task was completed')
            })
      })
    },

    getDeadlineDescription(task) {
      let diff = this.getDiff(task)

      if (diff === 0) {
        return 'Today'
      }

      if (diff === 1) {
        return 'Tomorrow'
      }

      if (diff === -1) {
        return 'Yesterday'
      }

      if (diff > 1) {
        return 'In ' + diff + ' days'
      }

      if (diff < 1) {
        return Math.abs(diff) + ' days ago'
      }
    },

    saveHeight() {
      if (this.$el.querySelector('.list-group')) {
        this.height = this.$el.querySelector('.list-group').clientHeight
      }
    },

    getDiff(task) {
      return moment(task.attributes.deadline_at).diff(moment().startOf('day'), 'days')
    }
  }
}
</script>
